// Force inject locale từ src/locales vào pro-layout
import { getLocale } from 'umi';
import viVNSettingDrawer from '../locales/vi-VN/settingDrawer'; // Dùng locale từ src/locales

console.log('🚀 Force injecting src/locales into pro-layout...');

// Tạo một formatMessage function hoàn toàn mới
const createCustomFormatMessage = () => {
  return ({ id, defaultMessage }: { id: string; defaultMessage?: string }) => {
    const currentLocale = getLocale();
    console.log(`📝 formatMessage called: id="${id}", locale="${currentLocale}"`);
    
    if (currentLocale === 'vi-VN') {
      const translation = (viVNSettingDrawer as Record<string, string>)[id];
      if (translation) {
        console.log(`✅ Vietnamese translation found: "${translation}"`);
        return translation;
      }
    }
    
    console.log(`⚠️ No translation found, using default: "${defaultMessage}"`);
    return defaultMessage || id;
  };
};

// Hijack pro-layout's getFormatMessage function
const hijackProLayoutFormatMessage = () => {
  console.log('🎯 Attempting to hijack pro-layout formatMessage...');
  
  // Method 1: Override trong webpack modules
  setTimeout(() => {
    try {
      const webpackRequire = (window as any).__webpack_require__;
      if (webpackRequire?.cache) {
        Object.values(webpackRequire.cache).forEach((module: any) => {
          if (module?.exports?.getFormatMessage) {
            console.log('🎯 Found getFormatMessage in webpack module');
            
            // Replace với custom implementation
            module.exports.getFormatMessage = () => {
              console.log('🔄 Custom getFormatMessage called');
              return createCustomFormatMessage();
            };
            
            console.log('✅ Successfully hijacked getFormatMessage');
          }
          
          // Cũng hijack formatMessage nếu có
          if (module?.exports?.formatMessage) {
            console.log('🎯 Found formatMessage in webpack module');
            module.exports.formatMessage = createCustomFormatMessage();
          }
        });
      }
    } catch (error) {
      console.warn('⚠️ Webpack hijack failed:', error);
    }
  }, 200);

  // Method 2: Global override
  (window as any).__PRO_LAYOUT_FORMAT_MESSAGE__ = createCustomFormatMessage();
  
  // Method 3: Monkey patch require
  const originalRequire = window.require;
  if (originalRequire) {
    (window as any).require = function(id: string) {
      const result = originalRequire(id);
      
      if (id.includes('pro-layout') && id.includes('SettingDrawer')) {
        console.log('🔧 Intercepted pro-layout SettingDrawer require');
        
        if (result?.getFormatMessage) {
          result.getFormatMessage = () => createCustomFormatMessage();
        }
      }
      
      return result;
    };
  }
};

// Direct DOM manipulation fallback
const directDOMTranslation = () => {
  console.log('🎨 Setting up direct DOM translation...');
  
  const translateElement = (element: Element) => {
    const chineseToVietnamese: Record<string, string> = {
      '整体风格设置': (viVNSettingDrawer as Record<string, string>)['app.setting.pagestyle'] || 'Cài đặt phong cách trang',
      '主题色': (viVNSettingDrawer as Record<string, string>)['app.setting.themecolor'] || 'Màu chủ đề',
      '导航模式': (viVNSettingDrawer as Record<string, string>)['app.setting.navigationmode'] || 'Chế độ điều hướng',
      '内容区域宽度': (viVNSettingDrawer as Record<string, string>)['app.setting.content-width'] || 'Độ rộng nội dung',
      '固定 Header': (viVNSettingDrawer as Record<string, string>)['app.setting.fixedheader'] || 'Cố định Header',
      '固定侧边菜单': (viVNSettingDrawer as Record<string, string>)['app.setting.fixedsidebar'] || 'Cố định menu bên',
      '其他设置': (viVNSettingDrawer as Record<string, string>)['app.setting.othersettings'] || 'Cài đặt khác',
      '色弱模式': (viVNSettingDrawer as Record<string, string>)['app.setting.weakmode'] || 'Chế độ mù màu',
      '拷贝设置': (viVNSettingDrawer as Record<string, string>)['app.setting.copy'] || 'Sao chép cài đặt',
    };

    // Translate text nodes
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null
    );

    const textNodes: Text[] = [];
    let node;
    while (node = walker.nextNode()) {
      textNodes.push(node as Text);
    }

    textNodes.forEach(textNode => {
      const text = textNode.textContent?.trim();
      if (text && chineseToVietnamese[text]) {
        console.log(`🔄 Translating: "${text}" → "${chineseToVietnamese[text]}"`);
        textNode.textContent = chineseToVietnamese[text];
      }
    });
  };

  // Monitor for SettingDrawer appearance
  const observer = new MutationObserver(mutations => {
    if (getLocale() !== 'vi-VN') return;
    
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as Element;
          
          // Check if it's SettingDrawer
          if (element.querySelector?.('[class*="setting-drawer"]') || 
              element.matches?.('[class*="setting-drawer"]')) {
            console.log('🎯 SettingDrawer detected, applying translations...');
            setTimeout(() => translateElement(element), 100);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also translate existing elements
  setTimeout(() => {
    if (getLocale() === 'vi-VN') {
      const settingDrawer = document.querySelector('[class*="setting-drawer"]');
      if (settingDrawer) {
        console.log('🎯 Found existing SettingDrawer, translating...');
        translateElement(settingDrawer);
      }
    }
  }, 1000);
};

// Execute all methods
hijackProLayoutFormatMessage();
directDOMTranslation();

// Listen for locale changes
window.addEventListener('storage', (e) => {
  if (e.key === 'umi_locale' && e.newValue === 'vi-VN') {
    console.log('🌍 Locale changed to vi-VN, triggering translation...');
    setTimeout(() => {
      const settingDrawer = document.querySelector('[class*="setting-drawer"]');
      if (settingDrawer) {
        directDOMTranslation();
      }
    }, 100);
  }
});

export default viVNSettingDrawer;
